/* eslint-disable no-console */

// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

// Setup polyfills according to the webpacker 5-x-stable documentation
import "core-js/stable"
import "core-js/features/object/entries"
import "regenerator-runtime/runtime"

// --- Mount-critical ---
// Everything React needs to mount must execute before Unpoly.start(): up.boot()
// compiles the initial page, and the [data-react-class] compiler mounts there,
// so the component registration below must already have run.
import "../components"

import Rails from "@rails/ujs"
import ReactRailsUJS from "react_ujs"
import Unpoly from "@/unpoly"

import * as ActiveStorage from "@rails/activestorage"
import "channels"

import setupAxios from "@/helpers/setupAxios"
import { initialize as initializeFlipflop } from "@/helpers/Flipflop"
import { initBrowserCompatibilityCheck } from "@/helpers/browserCompatibility"

// CSS is extracted in dev (hmr: false) and prod, so it is never in the JS execute
// path — import order here is irrelevant to the mount. Kept grouped for clarity.
import "bootstrap-icons/font/bootstrap-icons.css"
// FontAwesome as webfont CSS (SHO-TSK-1434): an <i class="fas fa-x"> stays the
// element React or the server rendered. Its SVG-with-JS mode replaced each
// marker with an <svg> behind React's back, so a conditionally rendered icon
// could crash the app with removeChild when the condition flipped.
import "@fortawesome/fontawesome-free/css/all.css"
import "react-bootstrap-typeahead/css/Typeahead.css"
import "primereact/resources/themes/bootstrap4-light-blue/theme.css"
import "primereact/resources/primereact.min.css"
import "primeicons/primeicons.css"

require.context("@/images", true)

Rails.start()
ActiveStorage.start()

/* global gon */
if (gon.global && gon.global.featureFlags) {
  initializeFlipflop(gon.global.featureFlags)
} else {
  console.warn("gon.global or gon.global.featureFlags is undefined")
}

// Register React components BEFORE the mount so ReactRailsUJS.getConstructor resolves.
// Exclude specs: webpack must not bundle test files (nor their jest-only deps)
// into the browser build.
ReactRailsUJS.useContext(require.context("@/", true, /^(?!.*(?:__tests__|\.test\.)).*components\//))
initBrowserCompatibilityCheck()
setupAxios()

// Fires the React mount: up.boot() compiles the initial page, mounting every
// [data-react-class]. All mount-critical work above runs first.
Unpoly.start()
